<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisConfirmModal from 'dashboard/components-next/LaisConfirmModal.vue';
import PostSaleNoteForm from './PostSaleNoteForm.vue';
import PostSaleNotesList from './PostSaleNotesList.vue';

defineProps({
  canManage: { type: Boolean, default: false },
  editingNote: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  notes: { type: Array, default: () => [] },
  saving: { type: Boolean, default: false },
  showForm: { type: Boolean, default: false },
});

const emit = defineEmits(['close-form', 'create', 'delete', 'edit', 'save']);
const { t } = useI18n();
const noteToDelete = ref(null);

const requestDelete = note => {
  noteToDelete.value = note;
};

const closeDelete = () => {
  noteToDelete.value = null;
};

const confirmDelete = () => {
  emit('delete', noteToDelete.value);
  closeDelete();
};
</script>

<template>
  <PostSaleNotesList
    :can-manage="canManage"
    :loading="loading"
    :notes="notes"
    @add="emit('create')"
    @delete="requestDelete"
    @edit="emit('edit', $event)"
  />

  <PostSaleNoteForm
    :key="editingNote?.id || 'new-note'"
    :note="editingNote"
    :saving="saving"
    :show="showForm"
    @close="emit('close-form')"
    @submit="emit('save', $event)"
  />

  <LaisConfirmModal
    :show="Boolean(noteToDelete)"
    :title="t('POST_SALE.NOTES.DELETE.TITLE')"
    :description="t('POST_SALE.NOTES.DELETE.DESCRIPTION')"
    :confirm-text="t('POST_SALE.NOTES.ACTIONS.DELETE')"
    icon="i-lucide-trash-2"
    @close="closeDelete"
    @confirm="confirmDelete"
  />
</template>
